var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    fill: "#fff",
    fillOpacity: 0.12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "No Image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.24,18.76A6,6,0,0,0,27,17.35V7a3,3,0,0,0-3-3H4A3,3,0,0,0,1,7V21a3,3,0,0,0,.27,1.23l0,0A3,3,0,0,0,4,24H19.09a6,6,0,1,0,10.15-5.24ZM21.56,25A4,4,0,0,1,27,19.56Zm-3.08-3L16,18.89l3-2.57,2.3,2a6.08,6.08,0,0,0-.54.47A6,6,0,0,0,19.09,22ZM4,6H24a1,1,0,0,1,1,1V17a6,6,0,0,0-1.81.28l-3.54-3a1,1,0,0,0-1.3,0l-3.61,3.09-4-5A1,1,0,0,0,10,12a1,1,0,0,0-.77.34L3,19.39V7A1,1,0,0,1,4,6ZM3.5,21.84,10,14.55l6,7.45H4A1,1,0,0,1,3.5,21.84Zm24.33,4a4.1,4.1,0,0,1-4.84.6L28.44,21a4,4,0,0,1-.61,4.85Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.b0f2e6242b94dd7dd327108dcd0191ea.svg";
export { ForwardRef as ReactComponent };